import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { studentLogApi } from "../../../api/y-te/studentLogApi";
import { toApiLanguage } from "../../../helpers/apiLanguage";
import { IBaseResponeModel } from "../../../models/response/base-response";
import {
	eStudentLogActionTypeIds,
	IStudentLogDeleteStart,
	IStudentLogLoadDetailStart,
	IStudentLogLoadStart,
	IStudentLogSaveStart
} from "../../action-types/y-te/IStudentLogActionTypes";
import { studentLogActions } from "../../actions/y-te/studentLogActions";

export function* studentLogSaga(): any {
	yield takeLatest(eStudentLogActionTypeIds.LOAD_START, loadStudentLogWorker)
	yield takeLatest(eStudentLogActionTypeIds.LOAD_DETAIL_START, loadStudentLogDetailWorker)
	yield takeEvery(eStudentLogActionTypeIds.SAVE_START, saveStudentLogWorker)
	yield takeEvery(eStudentLogActionTypeIds.DELETE_START, deleteStudentLogWorker)
}

function* loadStudentLogWorker(action: IStudentLogLoadStart): any {
	const res: IBaseResponeModel = yield call([studentLogApi, studentLogApi.Select], action.payload)
	if (res.is_success) {
		yield put(studentLogActions.loadStudentLogSuccess(res.data || []))
	} else {
		yield put(studentLogActions.loadStudentLogError(res.message || "Không tải được danh sách nhật ký y tế"))
	}
}

function* loadStudentLogDetailWorker(action: IStudentLogLoadDetailStart): any {
	const { id, language } = action.payload;
	const res: IBaseResponeModel = yield call([studentLogApi, studentLogApi.Detail], id, toApiLanguage(language))
	if (res.is_success) {
		if (res.data) {
			yield put(studentLogActions.loadStudentLogDetailSuccess(res.data))
		}
	} else {
		yield put(studentLogActions.loadStudentLogDetailError(res.message || "Không tải được chi tiết nhật ký y tế"))
	}
}

function* saveStudentLogWorker(action: IStudentLogSaveStart): any {
	let res: IBaseResponeModel;
	const is_update = action.payload.id > 0;
	if (is_update) {
		res = yield call([studentLogApi, studentLogApi.Update], action.payload as any);
	} else {
		res = yield call([studentLogApi, studentLogApi.Insert], action.payload as any);
	}
	if (res.is_success) {
		yield put(studentLogActions.saveStudentLogSuccess(is_update))
	} else {
		yield put(studentLogActions.saveStudentLogError(res.message || "Không lưu được nhật ký y tế"))
	}
}

function* deleteStudentLogWorker(action: IStudentLogDeleteStart): any {
	const res: IBaseResponeModel = yield call([studentLogApi, studentLogApi.Delete], action.payload)
	if (res.is_success) {
		yield put(studentLogActions.deleteStudentLogSuccess())
	} else {
		yield put(studentLogActions.deleteStudentLogError(res.message || "Không xoá được nhật ký y tế"))
	}
}
